import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyByT8j3m3QTdKlcNOXeevvd3hioq04vokM",
  authDomain: "omens-5071f.firebaseapp.com",
  projectId: "omens-5071f",
  storageBucket: "omens-5071f.firebasestorage.app",
  messagingSenderId: "516487949170",
  appId: "1:516487949170:web:8a185648dfb57e36a0cbeb",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Request notification permission + get FCM token
// Must be called AFTER the service worker is registered
export const requestPermission = async () => {
  try {
    if (!("Notification" in window)) {
      console.warn("⚠️ This browser does not support notifications.");
      return null;
    }

    if (Notification.permission === "denied") {
      console.warn("❌ Notification permission has been denied by the user.");
      return null;
    }

    if (Notification.permission !== "granted") {
      const result = await Notification.requestPermission();
      if (result !== "granted") {
        console.warn("❌ Permission denied by user.");
        return null;
      }
    }

    // Get or wait for the active service worker registration
    const swRegistration = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey:
        "BOCo563dt3Ft0n_dkwCdN8-gwAUpE3gmerpdrYJ9cpleGy3KjQ8hx0wjDnTU6tNRQeRnhzFmu9KeG9355UCXpKg",
      serviceWorkerRegistration: swRegistration,
    });

    if (token) {
      console.log("✅ FCM token:", token);
      return token;
    } else {
      console.warn("⚠️ No FCM token available.");
      return null;
    }
  } catch (error) {
    console.error("❌ Failed to get FCM token:", error);
    return null;
  }
};

export { messaging };
